import { countryIsoCode } from '@/constants/countryCode'
import { countryCodeEnum } from '@/constants/country'
import { apiAvailableChannel } from '@/resource/propTrading'
import { apiGetCpsAvailableChannel } from '@/resource/cps'
import { cpsDepositListingIndex } from '@/constants/cpsDepositListingIndex'
import { sortPayment } from '@/constants/payment/depositSetting.json'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      cpsDepositList: [],
      // availableChannelList: new Map(),
    }
  },
  computed: {
    ...mapState('common', ['userInfo']),
    getCountryIsoCode() {
      // 从前端常量获取当前的code
      let country = countryIsoCode.find(c => c.id === parseInt(this.$store.state.common.countryCode)).code
      if (!country) console.warn('当前国家暂不支持～');
      
      return country.code
    },
    // paymentLists() {
    //   let list = this.$platform.getPayments(this.regulator, this)
    //   let countryCode = this.$store.state.common.countryCode
    //   if (countryCode == countryCodeEnum.TURKEY) {
    //     // Special Handling for Turkey country
    //     list.forEach((v, i) => {
    //       if (v.dataTestid === 'localDepositor') {
    //         list.unshift(list[i])
    //         list.splice(i + 1, 1)
    //       }
    //     })
    //   }
    //   list = list
    //     .filter(payment => (payment.limitCountry ? this.limitPayment(payment) : true))
    //     .map(payment => {
    //       if (this.availableChannelList && this.availableChannelList.has(payment.dataTestid) && payment.toBeReplace) {
    //         const channel = this.availableChannelList.get(payment.dataTestid)
    //         payment.channelData = channel
    //       }
    //       return payment
    //     })
    //   return list
    // },
  },
  created() {
    // this.getAvailableChannelLits()
  },
  methods: {
    // async getAvailableChannelLits() {
    //   const resp = await apiAvailableChannel()
    //   const channelMap = new Map()
    //   if (resp.data.code === 0) {
    //     resp.data.data.forEach(channel => {
    //       channelMap.set(channel.name, channel)
    //     })
    //   }
    //   this.availableChannelList = channelMap
    // },
    // limitPayment(payment) {
    //   // debugger
    //   if (payment.hasOwnProperty('checkIdPass') && !payment.checkIdPass) return false
    //   if (payment.onlyThisCountry && this.countryCode === payment.onlyThisCountry) return true
    //   if (payment.restrictThisCountry && this.countryCode !== payment.restrictThisCountry) return true
    //   if (payment.allowCountry && payment.allowCountry.includes(this.countryCode)) return true
    //   if (payment.showPayment) return true

    //   return false
    // },
    getCPSDepositChannels(interalTest = false) {
      let payload = {
        country: this.getCountryIsoCode,
      }

      apiGetCpsAvailableChannel(payload).then(response => {
        let channelData = JSON.parse(response.data.data)
        console.log('channelData', channelData)

        // Assign cps deposit list
        this.cpsDepositList = channelData ? this.filterCpsDepositListByRegulator(channelData.channels, interalTest) : []
        console.log('this.cpsDepositList', this.cpsDepositList)
        // // concat paymentLists and cpsDepositList
        // const list = this.paymentLists.concat(this.cpsDepositList)

        // // sorting
        // this.depositChannelList = this.sortAllPayment(list)
      })
    },
    filterCpsDepositListByRegulator(channels, interalTest = false) {
      let finalCpsDepositList = []
      let parentArray = []
      let tradeAccountGroupArray = []
      let channelList = []
      let depositListOrder = []
      let sortedDepositList = []

      if (channels && channels.length > 0) {
        // check for merchant variable regulator
        channels.map(m => {
          let regulatorArray = []
          let merchantVariable = m.merchant_variable ? JSON.parse(m.merchant_variable) : ''
          m.merchant_variable = merchantVariable ? merchantVariable : ''

          let attachVariables = m.attach_variable ? Object.values(JSON.parse(m.attach_variable)) : ''
          m.attach_variable = attachVariables ? attachVariables : ''

          if (merchantVariable && merchantVariable.regulator) {
            regulatorArray = merchantVariable.regulator.split(',')
          }

          // push to final cps deposit list if regulator is matched & production is true
          if (regulatorArray.includes(this.regulator) && (merchantVariable.production || interalTest)) {
            // Exclude T00400 (Crypto) for merging trade_account
            if (m.payment_method === 'T00400') {
              tradeAccountGroupArray.push(m)
            } else {
              let paymentIndex = tradeAccountGroupArray.findIndex(function (p) {
                return p.payment_method === (merchantVariable.parent ? merchantVariable.parent : m.payment_method)
              })

              // create parent by payment method
              if (paymentIndex < 0) {
                tradeAccountGroupArray.push(m)
              }

              channelList.push(m)
            }
          }
        })

        // Start merging trade_account for the same payment method
        if (channelList.length > 0 && tradeAccountGroupArray.length > 0) {
          channelList.forEach((p, index) => {
            let paymentIndex = tradeAccountGroupArray.findIndex(function (pi) {
              return pi.payment_method === (p.merchant_variable.parent ? p.merchant_variable.parent : p.payment_method)
            })

            // only group when payment method matches
            if (paymentIndex >= 0) {
              // Create unique_currency under the child
              if (tradeAccountGroupArray[paymentIndex].actual_currency_code != p.actual_currency_code) {
                let actualCurrencyCodeObject = {}

                actualCurrencyCodeObject = {
                  actual_currency_code: p.actual_currency_code,
                  actual_currency_number: p.actual_currency_number,
                  currency_code: p.currency_code,
                  currency_number: p.currency_number,
                  regulator: p.merchant_variable.regulator,
                  trade_account: p.merchant_variable.trade_account,
                }

                if (!tradeAccountGroupArray[paymentIndex].hasOwnProperty('unique_currency')) {
                  let uniqueCurrencyArray = []

                  uniqueCurrencyArray = [
                    {
                      actual_currency_code: tradeAccountGroupArray[paymentIndex].actual_currency_code,
                      actual_currency_number: tradeAccountGroupArray[paymentIndex].actual_currency_number,
                      currency_code: tradeAccountGroupArray[paymentIndex].currency_code,
                      currency_number: tradeAccountGroupArray[paymentIndex].currency_number,
                      regulator: tradeAccountGroupArray[paymentIndex].merchant_variable.regulator,
                      trade_account: tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account,
                    },
                  ]

                  tradeAccountGroupArray[paymentIndex].unique_currency = uniqueCurrencyArray
                  tradeAccountGroupArray[paymentIndex].unique_currency.push(actualCurrencyCodeObject)
                } else {
                  tradeAccountGroupArray[paymentIndex].unique_currency.push(actualCurrencyCodeObject)
                }
              }

              // Merge trade account & limit
              if (
                tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account !=
                p.merchant_variable.trade_account
              ) {
                if (tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account) {
                  tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account =
                    tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account +
                    ',' +
                    p.merchant_variable.trade_account
                } else {
                  tradeAccountGroupArray[paymentIndex].merchant_variable.trade_account =
                    p.merchant_variable.trade_account
                }

                tradeAccountGroupArray[paymentIndex].merchant_variable.limit = tradeAccountGroupArray[
                  paymentIndex
                ].merchant_variable.limit.concat(p.merchant_variable.limit)
              }
            }
          })
        }

        // combine T00400 same crypto payments => create unique_crypto_currency under the child
        if (tradeAccountGroupArray.length > 0) {
          const actualCurrencyCodeObject = {}
          const accumulateLimitation = {}
          tradeAccountGroupArray.forEach(item => {
            if (item.payment_method === 'T00400') {
              let data = actualCurrencyCodeObject[item.actual_currency_code]
                ? [...actualCurrencyCodeObject[item.actual_currency_code]]
                : []

              let limit = accumulateLimitation[item.actual_currency_code]
                ? [...accumulateLimitation[item.actual_currency_code]]
                : []

              actualCurrencyCodeObject[item.actual_currency_code] = [
                ...data,
                {
                  account_aurrency: item.actual_currency_code,
                  currency_code: item.currency_code,
                  currency_number: item.currency_number,
                  regulator: item.merchant_variable.regulator,
                  trade_account: item.merchant_variable.trade_account,
                  limit: [...item.merchant_variable.limit],
                },
              ]

              const temp = [...limit, ...item.merchant_variable.limit]
              accumulateLimitation[item.actual_currency_code] = temp.filter(
                (item, index) => temp.indexOf(item) === index
              )
            }
          })

          tradeAccountGroupArray.map(item => {
            if (
              Object.keys(actualCurrencyCodeObject).includes(item.actual_currency_code) &&
              actualCurrencyCodeObject[item.actual_currency_code].length > 0
            ) {
              const data = [...actualCurrencyCodeObject[item.actual_currency_code]]
              data.map(d => (d.limit = [...accumulateLimitation[d.account_aurrency]]))
              item.unique_crypto_currency = [...data]
            }
          })

          tradeAccountGroupArray = tradeAccountGroupArray.filter((item, index) => {
            if (item.payment_method === 'T00400') {
              return (
                tradeAccountGroupArray.findIndex(
                  element => element.actual_currency_code === item.actual_currency_code
                ) === index
              )
            } else {
              return true
            }
          })
        }

        // Start create parent & child grouping
        if (tradeAccountGroupArray.length > 0) {
          tradeAccountGroupArray.map(m => {
            let paymentIndex = parentArray.findIndex(function (p) {
              return p.payment_method === (m.merchant_variable.parent ? m.merchant_variable.parent : m.payment_method)
            })

            // Create parent by payment method
            if (paymentIndex < 0) {
              let newPaymentMethod = m.merchant_variable.parent ? m.merchant_variable.parent : m.payment_method

              let paymentMethod = {
                payment_method: newPaymentMethod,
                description_title: m.description_title,
                processing_time: m.processing_time,
                fee: m.fee,
                child: [],
              }
              parentArray.push(paymentMethod)
            }

            finalCpsDepositList.push(m)
          })
        }

        // Start grouping and create child
        if (parentArray.length > 0) {
          finalCpsDepositList.forEach(p => {
            let paymentIndex = parentArray.findIndex(function (pi) {
              return pi.payment_method === (p.merchant_variable.parent ? p.merchant_variable.parent : p.payment_method)
            })

            if (paymentIndex != -1) {
              parentArray[paymentIndex].child.push(p)
            }
          })

          // Sort by order
          parentArray.forEach(pa => {
            let sortedArray = pa.child.sort((a, b) => a.merchant_variable.order - b.merchant_variable.order)
            pa.child = sortedArray
          })

          // Sort based on deposit listing index
          cpsDepositListingIndex.forEach(de => {
            if (de.id == this.countryCode) {
              depositListOrder = de.order
            }
          })

          if (depositListOrder.length == 0) {
            cpsDepositListingIndex.forEach(de => {
              if (de.id === 'global') {
                depositListOrder = de.order
              }
            })
          }

          depositListOrder.forEach(de => {
            parentArray.forEach(pa => {
              if (de === pa.payment_method) {
                sortedDepositList.push(pa)
              }
            })
          })

          let remainingPayments = parentArray.filter(v => !depositListOrder.includes(v.payment_method))
          sortedDepositList = sortedDepositList.concat(remainingPayments)
        }
      }

      return sortedDepositList
    },
    // sortAllPayment(sortedDepositList) {
    //   let countryCode = parseInt(this.$store.state.common.countryCode)
    //   sortPayment?.forEach(setting => {
    //     let countries = setting.country.map(el => countryCodeEnum[el])
    //     if (countries.includes(countryCode)) {
    //       let sortArray = setting[this.regulator] ? setting[this.regulator] : setting.default
    //       sortArray.forEach(el => {
    //         let positionIndex = el.position
    //         if (el.position === 'lastOne') {
    //           positionIndex = sortedDepositList.length - 1
    //         }

    //         if (['IBT', 'NigeriaGT'].includes(el.paymentMethod)) {
    //           this.localDepositSort(sortedDepositList, el.paymentMethod, positionIndex)
    //         } else {
    //           this.cpsSort(sortedDepositList, el.paymentMethod, positionIndex)
    //         }
    //       })
    //     }
    //   })

    //   return sortedDepositList
    // },
    cpsSort(sortedDepositList, method, idx) {
      const idnVirtualAccountItem = sortedDepositList.filter(e => e.payment_method === method)
      const idnVirtualAccountIndex = sortedDepositList.findIndex(e => e.payment_method === method)
      if (idnVirtualAccountItem && idnVirtualAccountItem.length) {
        sortedDepositList.splice(idnVirtualAccountIndex, 1)
        sortedDepositList.splice(idx, 0, idnVirtualAccountItem[0])
      }
      return sortedDepositList
    },
    localDepositSort(sortedDepositList, method, idx) {
      const item = sortedDepositList.filter(e => e.paymentMethod === method)
      const index = sortedDepositList.findIndex(e => e.paymentMethod === method)
      if (index >= 0) {
        sortedDepositList.splice(index, 1)
        sortedDepositList.splice(idx, 0, item[0])
      }
    },
  },
}
